// -*-mode: rjsx -*-
// REACT
import React, { Component } from "react"
import PropTypes from "prop-types"
// eslint-disable-next-line
import clsx from "clsx"

// ROUTER
// eslint-disable-next-line
import { Link, Redirect } from "react-router-dom"

// MUI
// eslint-disable-next-line
import { makeStyles, withStyles } from "@material-ui/core/styles"
import CssBaseline from "@material-ui/core/CssBaseline"
import Typography from "@material-ui/core/Typography"
//import ForwardIcon from '@material-ui/icons/Forward';
import ForwardIcon from '@material-ui/icons/ArrowForwardIos';
import grey from "@material-ui/core/colors/grey"


// FLASH
import FlashLogo from "../../../static/images/lightning-logo-transparent.png"

const styles = theme => ({


    fabDiv: {
        // position: "relative",
        // bottom: 50,
        // paddingRight: 20,
        display: "flex",
        justifyContent: "flex-end",
    },
    
    fab: {
        position: "fixed",
        //        bottom: theme.spacing(8),
        //        bottom: "5%",
        //        right: theme.spacing(1),
        //        left: "75%",
        // marginLeft: 400,
        //        marginLeft: "65%",
        //        marginTop: "-20%",
        zIndex: 10,

        width: 60,
        height: 60,


        //
        // mobile
        //
        [theme.breakpoints.down("md")]: {
            // marginTop: "-10%",
            bottom: "5%",
            right: "8%",
        },

        
        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            //            left: "60%",
            //            bottom: "20%",
            //            marginLeft: 400,
            //            marginLeft: "25%",
            //            marginTop: "0%",
        },

    },
    
    fabBlue: {
        color: theme.palette.common.white,
        //backgroundColor: theme.palette.custom.scrollDark,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.primary.light,
        },
    },
    
    //
    // proper styles
    //

    "@keyframes loginAnimation":  {
        "0%": {
            opacity: 1,
        },

        "40%": {
            opacity: 1,
        },
        
        "99%": {
            opacity: 0,
            width: "100%",
            height: "100%",
        },

        "100%": {
            opacity: 0,
            width: 0,
            height: 0,
        }
    },

    
    logoRoot: {
        position: "fixed",
        top: 0,
        left: 0,
        
        display: "flex",
        alignItems: "center", // vertical center
        justifyContent: "center", // horizontal center

        width: "100%",
        height: "100%",
        background: theme.palette.primary.main,
        zIndex: 1000,

        animationName: "$loginAnimation",
        animationDuration: "4s",
        animationFillMode: "forwards",

        userSelect: "none",
        
    },

    logoImg: {

        width: "40%",
        maxWidth: 200,

        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            // marginTop: -350,
            // marginTop: "-15%",
        },
        
    },

    // text page
    introRoot: {
        position: "fixed",
        top: 0,
        left: 0,
        
        display: "flex",
        flexDirection: "column",
        alignItems: "center", // vertical center
        justifyContent: "center", // horizontal center

        width: "100%",
        height: "100%",

        backgroundColor: "#FFFFFF",

        userSelect: "none",
        
    },

    introText: {
        margin: "auto",
        marginTop: "18%",
        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            marginTop: "5%",
        },
        paddingLeft: 40,
        paddingRight: 40,
        maxWidth: 600,
        backgroundColor: "#FFFFFF",
        zIndex: 1000
    },

    titleText: {
        color: theme.palette.primary.main,
        fontSize: 21,
    },

    continueText: {
        marginBottom: "0px",
        marginRight: "18px",
        color: theme.palette.primary.main,
        fontSize: "16px",
        fontWeight: "700"
    },
    

    titleLogo: {
        marginRight: 5,
        paddingBottom: 0,
        width: 62,
    },

    forwardArrow_old: {
        marginTop: -20,        
        width: 120,
        height: 120,
        color: theme.palette.primary.main,

        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            marginTop: -72,
            marginLeft: -230,        
        },
    },

    forwardButton: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        //justifyItems: "flex-center",
        width: "51px",
        height: "51px",
        borderRadius: "50%",
        backgroundColor: theme.palette.primary.main,
        boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)",
        "&:hover": {
            backgroundColor: "#438cffc2"
        }
    },
    
    forwardArrow: {
        //marginTop: -20,        
        //width: "25",
        //height: "25",
        fontSize: "28px",
        color: "white",
        marginLeft: "4px",
        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
//            marginTop: -72,
//            marginLeft: -230,        
        },
    }
    

})

let LogoComponent = withStyles(styles, { name: "LogoComponent" })(
    class LogoComponentBasis extends Component {
        render() {

            const { classes } = this.props
            
            return(
                <div className={classes.logoRoot}>
                  <img alt="logo" src={FlashLogo} className={classes.logoImg}/>
                </div>
            )
        }
    }
)


let IDashIntroComponent = withStyles(styles, { name: "IDashIntroComponent" })(
    class IDashIntroComponentBasis extends Component {

        // yes, we can redirect from children!

        state = {
            redirectToIDash: false,
            debugLayout: false
        }

        handleStartClick = () => {
            console.log("<IDashIntro>: handleStartClick()")
            this.setState({redirectToIDash: true})
        }
        
        render() {

            const { classes } = this.props

            const isTooSmall = window.matchMedia('(max-width: 600px)').matches

            // redirects first
            if (this.state.redirectToIDash) {
                return <Redirect push to="/idash"/>
            }
            
            
            return(
                <div className={classes.introRoot}>
                  <div className={classes.introText}>
                    <div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-end"}}>
                      <div className={classes.titleText}><b>Welcome to Lightning</b></div>
                      <div className={classes.titleLogo}>
                        <img alt="logo" src={FlashLogo} style={{width: "100%"}}/>
                      </div>
                    </div>
                    <div style={{marginTop: 10}}/>
                    <div>
                      <Typography variant="body1">
                        <p>Welcome to this prototype of “dashboards” for representatives to see the concerns of their constituents in some districts of California and Arizona.  They present you with data gathered and published 24/7.  All data is from real constituents by their district and zip code.  All issues and reasons are designed to be free of bias; the only bias is introduced by the constituents, themselves.</p>

                        {isTooSmall &&
                         <Typography variant="h6" style={{fontSize: 26, color:"#65676b", marginLeft: 25, marginTop: 20, marginBottom: 20, marginRight: 25}}>
                           <p>At this time, Dashboard works best on <b>Desktop</b>.</p>
                           <p>Please re-open on a large screen.</p>
                           <p>Thank you for testing!</p>
                         </Typography>
                        }

                        {isTooSmall !== true && <span>
                          <p>The data in this demo will be driven from constituents in zip codes: 94010, 94025, 94027 and 94301 plus 85132 in Arizona.  They are being asked to provide their comments through a free constituent app.  The main audience for them is Senator Feinstein and House Members Eshoo and Speier.  This will run for 3 days; please come and visit your dashboard several times during this run so you can see how things change.</p>
                          <p>This is a “first pass”; <u>there may be “hiccups”</u>.  We have many enhancements which we will implement in the weeks ahead.</p>
                          <p>Please send your comments to <a href="mailto:info@feedbakdata.com">info@feedbakdata.com</a>; your feedback will help us increase its value to you.</p>
                          </span>
                        }
                    </Typography>
                    </div>
                    {isTooSmall !== true && <span>
                    
                    <div style={{marginTop: 15}}/>
                    <div>
                    </div>
                    <div style={{marginTop: 20}}/>
                    
                    <span onClick={this.handleStartClick}
                          style={{ cursor: "pointer" }}>

                    <div style={{
                        backgroundColor: this.state.debugLayout ? grey[800] : "inherit",
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                        //justifyContent: "space-between",
                        justifyContent: "center",
                        alignItems: "center",
                        marginRight: "auto"
                    }}>
                      <div className={classes.continueText}>CONTINUE</div>
                      <div className={classes.forwardButton}>
                        <ForwardIcon className={classes.forwardArrow}/>
                      </div>                
                    </div>
                    </span>
                     </span>
                    }
                  </div>
                </div>
            )
        }
    }
)

class IDashIntro extends Component {

    render() {
        
        // const { classes } = this.props

	return(
            <React.Fragment>
	      <CssBaseline/>
              <LogoComponent/>
              <IDashIntroComponent/>
            </React.Fragment>
	)
    }
}

IDashIntro.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles, { name: "IDashIntro" })(IDashIntro)

